module.exports = __webpack_public_path__ + "static/media/logo.6d72cf78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = 412
// module chunks = 0